import { IMaskInput } from "react-imask";
import { BootstrapInput } from "../../../utils/styles";
import { makeStyles } from "@material-ui/core";

interface CustomProps {
  id: string;
  onChange: Function;
  placeholder?: string;
  mask: string;
  className: any;
  name?: string;
  endAdornment?: any;
  autoComplete?: string;
}

const useStyles = makeStyles((theme) => ({
  box: {
    width: "100%",
    borderRadius: "16px",
    height: "50px",
  },
}));

const CustomMaskComponent = (props: CustomProps) => {
  const classes = useStyles();
  const handleChange = (event: any) => {
    const unmaskedValue = event.target.value;
    if (props.onChange) {
      props.onChange(unmaskedValue, props.name ?? "");
    }
  };

  return (
    <BootstrapInput
      className={props.className ?? classes.box}
      placeholder={props.placeholder ?? ""}
      inputComponent={IMaskInput}
      inputProps={{
        id: props.id,
        mask: props.mask,
        unmask: false,
        onAccept: (value: string, mask: any) =>
          props.onChange(value, props.name ?? ""),
        ...(props.autoComplete && { autoComplete: props.autoComplete }),
      }}
      onChange={handleChange}
      {...(props.endAdornment && { endAdornment: props.endAdornment })}
    />
  );
};

export default CustomMaskComponent;
